import { render, staticRenderFns } from "./mFinish.vue?vue&type=template&id=48d5161d&scoped=true&"
import script from "./mFinish.vue?vue&type=script&lang=js&"
export * from "./mFinish.vue?vue&type=script&lang=js&"
import style0 from "./mFinish.vue?vue&type=style&index=0&id=48d5161d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d5161d",
  null
  
)

export default component.exports